import { r as registerInstance, c as createEvent, h, g as getElement } from './index-d4808923.js';
import { b as bem } from './index.esm-7182addc.js';

const gravityFileInputCss = ":host{display:block}.gravity-file-input{display:flex}.gravity-file-input__input-block{display:flex;position:relative}.gravity-file-input__hidden-input{height:100%;opacity:0;pointer-events:none;position:absolute;width:100%}.gravity-file-input__button-label{align-items:center;background-color:transparent;border:1px solid rgba(0, 15, 30, 0.2);border-radius:6px;box-sizing:border-box;cursor:pointer;display:inline-flex;gap:6px;height:40px;justify-content:center;padding:0 16px;white-space:nowrap}.gravity-file-input__button-label:hover,.gravity-file-input__hidden-input:active+.gravity-file-input__button-label{background-color:rgba(0, 15, 30, 0.05)}.gravity-file-input__hidden-input:focus-visible+.gravity-file-input__button-label{outline:#1B6AEE solid 2px;outline-offset:2px}.gravity-file-input--invalid .gravity-file-input__button-label{border-color:#DB0A40}.gravity-file-input__file-name{align-self:center;margin-inline-start:12px;min-width:0}.gravity-file-input--disabled .gravity-file-input__input-block{pointer-events:none}.gravity-file-input--disabled .gravity-file-input__button-label{border-color:rgba(0, 15, 30, 0.1)}.gravity-file-input--size-small .gravity-file-input__button-label{border-radius:4px;gap:4px;height:32px;padding:0 12px}.gravity-file-input--size-small .gravity-file-input__file-name{margin-inline-start:8px}";
const GravityFileInputStyle0 = gravityFileInputCss;

const generateClassNames = bem('gravity-file-input');
const GravityFileInput = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.fileChange = createEvent(this, "fileChange", 7);
        this.computeSelectedFilesName = () => {
            var _a;
            if (((_a = this.selectedFiles) === null || _a === void 0 ? void 0 : _a.length) === 1) {
                return this.truncateFileName(this.selectedFiles[0].name, 21);
            }
            else if (this.selectedFiles.length > 1) {
                return `${this.selectedFiles.length} files selected`;
            }
        };
        this.handleFileInput = () => {
            this.selectedFiles = this.fileInput.files;
            this.fileChange.emit(this.selectedFiles);
        };
        this.accept = undefined;
        this.buttonLabel = undefined;
        this.disabled = false;
        this.iconName = 'upload';
        this.infoBottom = false;
        this.infoPosition = 'top';
        this.infoText = '';
        this.infoWidth = undefined;
        this.inline = false;
        this.inlineLabelWidth = '33%';
        this.invalid = false;
        this.label = undefined;
        this.multiple = undefined;
        this.required = false;
        this.size = 'medium';
        this.validationMessage = '';
        this.selectedFiles = null;
    }
    /**
     * Clears the selected file(s) from the file input.
     * @public
     */
    async clearSelection() {
        this.fileInput.value = '';
        this.selectedFiles = null;
    }
    /**
     * Sets focus on the file input.
     * @public
     */
    async inputFocus() {
        this.fileInput.focus();
    }
    truncateFileName(fileName, maxLength) {
        if (fileName.length < maxLength) {
            return fileName; // No need to clamp
        }
        const ellipsis = '...';
        const ellipsisLength = ellipsis.length;
        const prefixLength = Math.ceil((maxLength - ellipsisLength) / 2);
        const suffixLength = Math.floor((maxLength - ellipsisLength - 1) / 2);
        const clampedName = fileName.substring(0, prefixLength) + ellipsis + fileName.substring(fileName.length - suffixLength);
        return clampedName;
    }
    render() {
        return (h("gravity-form-field", { key: 'cc96793b866609199e3cd5af87dbde8b8c139a5f', invalid: this.invalid, disabled: this.disabled, size: this.size, label: this.label, infoText: this.infoText, infoBottom: this.infoBottom, infoWidth: this.infoWidth, infoPosition: this.infoPosition, inline: this.inline, required: this.required, infoInline: this.inline ? false : true, inlineLabelWidth: this.inlineLabelWidth, validationMessage: this.validationMessage }, h("div", { key: '360d037c112d620eec0b9e21543267781c5a364c', class: generateClassNames({
                invalid: this.invalid,
                disabled: this.disabled,
                size: this.size,
            }) }, h("div", { key: 'e66422b9322fcc0066e41f2db88c2bed7f1e2735', class: generateClassNames('input-block') }, h("input", { key: '2309117038aa9e57ee321710f76b81215837928d', accept: this.accept, class: generateClassNames('hidden-input'), id: "file-input", multiple: this.multiple, onChange: this.handleFileInput, ref: (el) => (this.fileInput = el), required: this.required,
            // Disable browser's default tooltip
            title: "", type: "file", disabled: this.disabled }), h("label", { key: 'e13b5d9d16afca9416fc1f0f57c3f953b1db0efa', class: generateClassNames('button-label'), htmlFor: "file-input" }, h("gravity-icon", { key: 'd19940c877508da85e6cf30bd7501cd50d0fc281', color: this.disabled ? 'dark-muted' : 'dark', size: this.size === 'small' ? 'xxx-small' : 'xx-small', name: this.iconName }), h("gravity-text", { key: '177a7df7dadc2228f60acf67373917c25211d0c7', color: this.disabled ? 'dark-muted' : 'dark', size: this.size == 'small' ? 'x-small' : 'small', weight: "medium" }, this.buttonLabel))), this.selectedFiles && (h("gravity-text", { key: '60643388cb4b2b78cdcba0bf66dc46be63ed42ac', clamp: 1, class: generateClassNames('file-name'), size: this.size == 'small' ? 'x-small' : 'small', weight: "medium" }, this.computeSelectedFilesName())))));
    }
    get element() { return getElement(this); }
};
GravityFileInput.style = GravityFileInputStyle0;

export { GravityFileInput as gravity_file_input };

//# sourceMappingURL=gravity-file-input.entry.js.map